import { Timestamp } from "firebase/firestore";

import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { Company } from "@/features/modules/company/objects/Company";
import { companyModel } from "@/features/modules/company/models/CompanyModel";
import { ContractExpiration } from "@/features/modules/contract/objects/ContractExpiration";
import { firmModel } from "@/features/modules/firm/models/FirmModel";
import { Widget } from "@/core/modules/widget/objects/Widget";
import { widgetModel } from "@/core/modules/widget/models/WidgetModel";

export const getExpiringContractsByFirm = async (): Promise<ContractExpiration[]> => {
  try {
    const contractExpirations: ContractExpiration[] = [];

    const firmId: string = firmModel.getSelectedFirmId();

    const companies: Company[] = await companyModel.getCompaniesWithTrackExpirations();
    const widgets: Widget[] = await widgetModel.getWidgetsByTypeAndSource("expiringContracts", firmId);

    for (const company of companies) {
      if (company.trackExpirations === false) continue;

      const companyWidget: Widget | undefined = widgets.find((widget) => widget.source === firmId && widget.sourceId === company.id);
      if (companyWidget === undefined) continue;
      if (companyWidget.values.count === 0) continue;
      if (companyWidget.values.expiration == undefined) continue;

      const expiration: Timestamp = companyWidget.values.expiration as Timestamp;
      contractExpirations.push(new ContractExpiration(company.id, company.name ?? "-", expiration.toDate()));
    }

    return contractExpirations;
  } catch (error: unknown) {
    appFaultModel.catchAppError("ContractModel.getExpiringContractsByFirm", {}, error);
    return [];
  }
};
